/**
 * Runtime configuration accessor.
 *
 * Values are injected at container start by docker/docker-entrypoint.sh, which
 * writes /usr/share/nginx/html/env-config.js -> window.__ENV__. This lets a single
 * Docker image be promoted through dev/xat/prod without rebuilding.
 *
 * For local development, public/env-config.js provides the same global.
 */
export function getConfig(key) {
  if (window.__ENV__ && window.__ENV__[key]) {
    return window.__ENV__[key];
  }
  return '';
}

export default getConfig;
